<template>
  <input
    type="text"
    :value="inputValue"
    :placeholder="placeholder"
    :disabled="disabled"
    style="ime-mode: disabled"
    @keydown="keydownHandle"
    @blur="blurHandle"
    @focus="focusHandle"
    @paste="pasteHandle"
    @input="inputHandle"
    ref="inputRef"
  />
</template>

<script setup lang="ts">
// import { ref, defineProps, defineEmits } from 'vue';
// import NP from 'number-precision';
import numbro from 'numbro';

// import { scientificNumber, filterPrecision } from '~/common/js/utils';
// import BigNumber from 'bignumber.js';

const props = defineProps({
  step: {
    type: Number,
    default: 1,
  },
  modelValue: {
    type: String, // maybe number
  },
  thousandSeparated: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  precision: {
    type: Number,
    default: 6, // 默认精度
  },
  startWithZero: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  max: {
    type: [Number, String, null],
    default: null,
  },
});
const emit = defineEmits(['update:modelValue','input','blur','focus']);

const inputRef = ref<HTMLInputElement|null>();
const inputValue = ref(props.modelValue);

watch([()=>props.modelValue, ()=>props.precision], ([newValue, newPrecision], [oldValue, oldPrecision]) => {
  if(props.modelValue!== inputValue.value || newPrecision !== oldPrecision){
    nextTick(()=>inputValue.value = getNumberFormatted(newValue));
  }
});

watch(inputValue, (newValue) => {
  emit('update:modelValue', newValue);
});

// 格式化数字 展示为千分位分隔符；精度截取
const getNumberFormatted = (value?: string | number) =>{
  if (!value) return '';
  let v = getRawValue(value?.toString?.());
  if(isNaN(parseFloat(v))){
    return '';
  }
  let [integer, decimal] = v.split('.');
  // console.log(integer, decimal);
  const dotIndex = v.indexOf('.');

  if(Boolean(props.thousandSeparated)){
    integer = numbro(integer).format({ thousandSeparated: true });
  }

  if(props.precision >=0 && decimal?.length > props.precision){
    decimal = decimal.slice(0, props.precision);
  }else if(props.precision === 0){
    decimal = '';
  }
  console.log("precision",props.precision, "number:",integer, decimal, "[",dotIndex,"]");
  if(props.precision === 0){
    return integer;
  }
  if (dotIndex > -1) {
    return `${integer??''}.${decimal||''}`;
  } else {
    return integer;
  }
};

const keydownHandle = (e: KeyboardEvent) => {
  if (e.key === 'ArrowUp') { // 上箭头
    adjustValue(props.step);
  }
  if (e.key === 'ArrowDown') { // 下箭头
    adjustValue(-props.step);
  }
};

const inputHandle = (e:Event) => {
  const unformattedValue = (e.target as HTMLInputElement).value;

  const rawValue = unformattedValue?.replace?.(/,/g,'');

  if(isNaN(Number(rawValue))){
    // 只是最后一位是.
    if(rawValue[rawValue.length-1] === '.' && !isNaN(Number(rawValue.slice(0,-1)))){
      
    }else{
      // @ts-ignore
      e.target.value = getNumberFormatted(inputValue.value);
      return;
    }
  };
  
  const inputElement = inputRef.value;
  
  // emit('update:modelValue', rawValue);
  const formattedValue = getNumberFormatted(rawValue);
  
  const cursorPosition = inputElement?.selectionStart||0;

  // @ts-ignore
  e.target.value = formattedValue;// 光标位置已经变了
  inputValue.value = formattedValue;


  // 计算光标位置变化
  // 获取输入框的当前光标位置
  // debugger
  
  const diff = formattedValue?.length - unformattedValue?.length;
  // console.log("cursorPosition",cursorPosition,"diff",diff,);
  const newPosition = cursorPosition + diff;
  // console.log("newPosition",newPosition,);
  // let oldSelectionEnd = this.$refs.input.selectionEnd
  //       const oldDistanceToEnd = inputInnerValue.length - oldSelectionEnd
  //       newSelectionEnd = newFormatedValue.length - oldDistanceToEnd

  inputElement?.setSelectionRange(newPosition, newPosition);


  // 更新格式化后的值

  // 触发 input 事件，发送原始值
  emit('input', formattedValue);
};

const adjustValue = (delta: number) => {
  // 暂时不使用上下键调整数据大小，因为会导致输入框的光标位置变化
  // const inputValue = getRawValue(props.value);
  // const rawValue = getRawValue(inputValue);
  // const newValue = NP.plus(+rawValue, delta);
  // if (props.max === null || newValue <= Number(props.max)) {
  //   emit('input', newValue.toString());
  // }
};

const getRawValue = (value: string|number) => {
  // 移除格式化字符，返回原始值
  const v = value?.toString?.();
  return v.replace(/[^\d.]/g, '');
};

// const formatValue = (value: string) => {
//   if (!value) return '';
//   // 处理输入格式，保留有效数字
//   let newValue = value.replace(/[^\d.]/g, ''); // 只保留数字和小数点
//   const parts = newValue.split('.');
//   if (parts.length > 1) {
//     // 限制小数位数
//     newValue = `${parts[0]}.${parts[1].slice(0, props.precision)}`;
//   }
//   if (props.startWithZero && newValue.startsWith('0') && newValue.length > 1) {
//     // 处理开头为0的情况
//     newValue = newValue.replace(/^0+/, '0');
//   }
//   return formatToDisplay(newValue);
// };

// const formatToDisplay = (value: string) => {
//   if (!value) return '';
//   // 将原始值格式化为显示值
//   const [integerPart, decimalPart] = value.split('.');
//   const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
// };

const blurHandle = (e:Event) => {
  emit('blur');
};

const focusHandle = () => {
  emit('focus');
};

const pasteHandle = (e: ClipboardEvent) => {
  // 处理粘贴事件，只允许粘贴数字和小数点
  e.preventDefault();
  const clipboardText = e.clipboardData?.getData('text/plain');
  
  if (clipboardText && !isValidPaste(clipboardText)) {
    e.preventDefault();
  }else{
    // @ts-ignore
    e.target.value = getNumberFormatted(clipboardText);
  }
};

const isValidPaste = (value: string) => {
  // 检查粘贴的值是否有效
  const rawValue = String(value);
  const regex = /^[\d.,]*$/;
  return regex.test(rawValue);
};
</script>
